import {
  CINEMA_LANGUAGES,
  DEFAULT_CINEMA_HANDLER,
  DEFAULT_CINEMA_LANGUAGE,
  isValidCinemaSlug,
} from "~/utils/constants";

export const useBuildMetaTags = () => {
  const requestURL = useRequestURL();
  const langPattern = Object.keys(CINEMA_LANGUAGES).join("|");

  const setCanonicalLink = (isDuplicatePage = false) => {
    let pathName = requestURL.pathname;
    if (isDuplicatePage) {
      const url = pathName.split("/");
      const cinemaSlug = url?.[2] && isValidCinemaSlug(url[2]) ? url[2] : null;
      if (cinemaSlug) {
        pathName = pathName.replace(
          `/${cinemaSlug}`,
          `/${DEFAULT_CINEMA_HANDLER}`,
        );
      }
    }
    const href = `${requestURL.origin}${pathName}`;
    useHead({ link: [{ rel: "canonical", href }] });
  };

  const getAlternateLinks = () => {
    return Object.values(CINEMA_LANGUAGES).map((lang) => {
      const hreflang = lang === DEFAULT_CINEMA_LANGUAGE ? "x-default" : lang;
      const href = requestURL.href.replace(
        new RegExp(`\/(${langPattern})\/`),
        `/${lang}/`,
      );
      return { rel: "alternate", hreflang, href };
    });
  };

  const getAlternateLinksFromCraftUris = (cinemaSlug, pages) => {
    return pages.map((page) => {
      const lang =
        page.language === "cs-CZ" ? DEFAULT_CINEMA_LANGUAGE : page.language;
      const hreflang = lang === DEFAULT_CINEMA_LANGUAGE ? "x-default" : lang;
      const href = requestURL.origin + `/${lang}/${cinemaSlug}/${page.uri}`;
      return { rel: "alternate", hreflang, href };
    });
  };

  const setHomepageHrefLangs = () => {
    try {
      const links = getAlternateLinks();
      useHead({ link: links });
    } catch (error) {
      console.error("Error setting homepage href langs:", error);
    }
  };

  const setOtherPageHrefLangs = (cinemaSlug, pages) => {
    try {
      if (!cinemaSlug || pages?.length === 0) {
        return;
      }
      const links = getAlternateLinksFromCraftUris(cinemaSlug, pages);
      useHead({ link: links });
    } catch (error) {
      console.error("Error setting other page href langs:", error);
    }
  };

  const setMovieDetailPageHrefLangs = () => {
    try {
      const links = getAlternateLinks();
      useHead({ link: links });
    } catch (error) {
      console.error("Error setting movie detail href langs:", error);
    }
  };
  return {
    setCanonicalLink,
    setHomepageHrefLangs,
    setOtherPageHrefLangs,
    setMovieDetailPageHrefLangs,
  };
};
